/**
 * The `/tel` export's transport, bound by the composition root to its principal fetch (flashcards-local-first.spec.md
 * PrincipalFetch: the boundary decides credentials per principal). The exporter exists before the auth client does, so
 * an export queued before the binding waits for it.
 */
export function boundTransport() {
  let bound = Promise.withResolvers<Window['fetch']>()
  let current: Window['fetch'] | undefined
  return {
    fetch: (async (input: RequestInfo | URL, init?: RequestInit) => (current ?? await bound.promise)(input, init)) as Window['fetch'],
    bind(this: void, fetch: Window['fetch']) { current = fetch; bound.resolve(fetch); bound = Promise.withResolvers() },
  }
}
